import type { Client } from "features/Clients/types/client.types";

/** Prefer organization name, then company name. */
export function getClientDisplayName(
  client: Pick<Client, "name" | "company"> | null | undefined,
): string {
  if (!client) return "—";
  const org = String(client.name ?? "").trim();
  if (org) return org;
  const co = String(client.company ?? "").trim();
  if (co) return co;
  return "—";
}
